import moment from "moment"

export const LIVE_DAY = { PAST: "past", TODAY: "today", FUTURE: "future" }

// Where a live's day stands against today, read from the clock when asked —
// never from a render, which a screen left open overnight keeps frozen. A
// past day means the data was loaded before the live took place.
export function liveDayFromToday(date, now = moment()) {
    if (!date) return null
    const day = moment(date)
    if (day.isSame(now, "day")) return LIVE_DAY.TODAY
    return day.isBefore(now, "day") ? LIVE_DAY.PAST : LIVE_DAY.FUTURE
}

// The next live of these sessions: the first occurrence neither finalized nor
// over by the calendar, so a live left from yesterday in stale data is skipped.
export function nextLiveFromToday(liveSessions, now = moment()) {
    return liveSessions
        ?.flatMap((session) => session?.next_occurrences ?? [])
        .filter(
            (occurrence) =>
                !occurrence?.finalized_at &&
                liveDayFromToday(occurrence?.date, now) !== LIVE_DAY.PAST
        )
        .sort((a, b) => moment(a.date).diff(b.date))[0]
}
